<template>
  <div style="height:100%;width:100%; display: flex;flex-direction: column;">
    <div style="height:50px;width:100%;background-color:#f8f8f8;">
      <div style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
        <div style="width:40%;display:flex">
          <div style="width:4px;background-color:#970B0B;height:40px"></div>
          <div style="margin:5px;color:#970B0B;">反馈信息</div>
        </div>
        <div style="width:50%;justify-content: center;display: flex;">
        </div>
        <div style="width:15%;color:#970B0B">
          <el-button @click="RightAddClick" size="mini"
            style="width:70%;background-color:#970B0B;color:#fff">新增反馈信息</el-button>
        </div>
      </div>
    </div>
    <div style="width:100%;height:100%">
      <el-table :data="fadebackList" height="500px" size="medium" style="width: 100%;height:100%;">
        <el-table-column fixed prop="id" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="title" label="标题" width="100">
        </el-table-column>
        <el-table-column prop="username" label="反馈人" width="100">
        </el-table-column>
        <el-table-column prop="phonenumber" label="手机号" width="150">
        </el-table-column>
        <el-table-column prop="content" label="反馈内容" width="150">
        </el-table-column>
        <el-table-column prop="createDate" label="反馈时间" width="200">
        </el-table-column>
        <el-table-column prop="origin" label="来源" width="100">
        </el-table-column>
        <el-table-column prop="updateDate" label="受理时间" width="200">
        </el-table-column>
        <el-table-column prop="solveusername" label="受理人" width="150">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="80%" center :destroy-on-close=true :show-close=false
      :close-on-click-modal=false :close-on-press-escape=false>
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">
            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">反馈详细</div>
            </div>
            <div style="width:50%;"></div>
            <div style="width:15%;"></div>
          </div>
        </div>
        <div style="color:#970B0B;margin-top:20px;width:100%;height:60px;background-color:#f8f8f8;display:flex">
          <div style="width:50px;margin-left:5px;margin-right:15px;color:#970B0B;">标题：</div>
          <el-input style="width:50%;" placeholder="请输入标题" v-model="fadebackInfo.title" type="text" clearable>
          </el-input>
          <div style="width:50px;margin-left:5px;margin-right:15px;color:#970B0B;">反馈人</div>
          <el-input style="width:50%;" placeholder="请输入反馈人" v-model="fadebackInfo.username" type="text" clearable>
          </el-input>
        </div>

        <div style="background-color:#f8f8f8;color:#970B0B;margin-top:20px;width:50%;height:60px"
          class="container_right">
          <div style="flex: 1;display: flex;margin:10px;width:50%">
            <div style="width:50px;margin-left:5px;margin-right:15px;color:#970B0B;">反馈内容：</div>
            <el-input style="width:50%;" placeholder="请输入反馈内容" v-model="fadebackInfo.content" type="text" clearable>
            </el-input>
          </div>
        </div>
        <div style="background-color:#f8f8f8;color:#970B0B;margin-top:20px;width:50%;height:60px"
          class="container_right">
          <div style="flex: 1;display: flex;margin:10px;width:50%">
            <div style="width:52px;margin-left:5px;margin-right:15px;color:#970B0B;">手机号</div>
            <el-input style="width:50%;" placeholder="请输入手机号" v-model="fadebackInfo.phonenumber" type="text" clearable>
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer ">
        <el-button style="width:120px" @click="centerDialogVisible = false">取 消</el-button>
        <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="updateFeedBack(fadebackInfo.id)">确
          定</el-button>
      </span>
    </el-dialog>


     <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>


  </div>

</template>

<script>
import TMApipath from 'TMApipath'
import { formatTime } from 'TMUtils'

export default {
  methods: {
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getAllFadeBack(_this.pageInfo.val,_this.pageInfo.size);
      },
    handleDelete(index, rows) {
      var _this = this;
      _this.$confirm('此操作将永久删除该反馈信息, 是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        _this.deleteFeedBackById(rows.id); // 根据您的数据结构确定使用哪个属性作为行的唯一标识符
      }).catch(() => {
        // 用户取消删除操作
      });
    },
    handleEdit(index, row) {
      this.centerDialogVisible = true;
      this.fadebackInfo = {
        id: row.id, // 设置编辑的反馈信息的ID
        title: row.title,
        username: row.username,
        content: row.content,
        phonenumber: row.phonenumber,
        solveusername: row.solveusername
      };
    },
    updateFeedBack() {
      var _this = this;

      if (!_this.fadebackInfo.username || !_this.fadebackInfo.title || !_this.fadebackInfo.phonenumber || !_this.fadebackInfo.content) {
        this.$message.error("请填写相关必填信息");
        return;
      }

      var params = {
        id: _this.fadebackInfo.id,
        title: _this.fadebackInfo.title,
        username: _this.fadebackInfo.username,
        phonenumber: _this.fadebackInfo.phonenumber,
        content: _this.fadebackInfo.content,
      };

      var reqdata = {};
      var { urls } = _this.getresult(TMApipath.FEEDBACK, TMApipath.URL_API_ADDFEEDBACK, reqdata);

      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.centerDialogVisible = false;
          _this.fadebackList = []; // 清空原先数据
          _this.getAllFadeBack("", _this.pageInfo.val, _this.pageInfo.size); // 重新获取数据

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response);
      });
    },

    addFeedBack() {
      var _this = this;

      if (!_this.fadebackInfo.username || !_this.fadebackInfo.title || !_this.fadebackInfo.phonenumber || !_this.fadebackInfo.content) {
        this.$message.error("请填写相关必填信息");
        return;
      }

      var params = {
        phonenumber: _this.fadebackInfo.phonenumber,
        username: _this.fadebackInfo.username,
        title: _this.fadebackInfo.title,
        content: _this.fadebackInfo.content,
        origin: _this.fadebackInfo.origin
      };

      var reqdata = {};
      var { urls } = _this.getresult(TMApipath.FEEDBACK, TMApipath.URL_API_EDITFEEDBACK, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.centerDialogVisible = false;
          // 成功添加反馈信息后调用获取数据的方法以更新页面数据
          _this.getAllFadeBack("", _this.pageInfo.val, _this.pageInfo.size);
        } else {
          _this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        _this.$message.error("系统异常");
        console.log(response);
      });
    },
    RightAddClick() {
      this.centerDialogVisible = true;
      this.fadebackInfo = {
        id: "",
        username: "",
        phonenumber: "",
        title: "",
        content: "",
        solveusername: "",
      }

    },
    getAllFadeBack(project, pageIndex, pageSize) {

      var _this = this
      var reqdata = { project: project, pageIndex: pageIndex, pageSize: pageSize }
      var { urls } = _this.getresult(TMApipath.FEEDBACK, TMApipath.URL_API_GETFEEDBACKLISTBYPAGE, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          // vuex记录
          _this.groupIist = [];
          _this.pageInfo.total = response.data.total
          for (var items in response.data.list) {
            var item = response.data.list[items]
            var cutFeed = {
              id: item.id,
              username: item.username,
              phonenumber: item.phonenumber,
              title: item.title,
              content: item.content,
              origin: item.origin,
              flag: item.flag,
              solveflag: item.solveflag,
              solveaid: item.solveaid,
              solveusername: item.solveusername,
              solvecontent: item.solvecontent,
              createDate: formatTime(item.createDate),
              updateDate: item.updateDate ? formatTime(item.updateDate) : '--',
            }

            _this.fadebackList.push(cutFeed);
          }


        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });

    },
    deleteFeedBackById(id) {
      var _this = this
      var params = {
        id: id,
      }
      var reqdata = {}
      var { urls } = _this.getresult(TMApipath.FEEDBACK, TMApipath.URL_API_DELETEFEEDBACK, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.centerDialogVisible = false;
          // 清空数据
          _this.fadebackList = [];
          // 更新页面信息
          _this.pageInfo.total -= 1; // 减少总数，因为我们删除了一项
          if (_this.fadebackList.length === 1 && _this.pageInfo.val > 1) {
            _this.pageInfo.val -= 1; // 如果删除了当前页的最后一项，则减少页面数
          }
          // 重新获取数据
          _this.getAllFadeBack("", _this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      var _this = this
      _this.pageInfo.val = val
      _this.getAllFadeBack("", _this.pageInfo.val, _this.pageInfo.size);
    },
  },


  mounted() {
    var _this = this
    _this.getAllFadeBack("", _this.pageInfo.val, _this.pageInfo.size);

  },
  data() {

    return {
      isGroupEdit: false,
      pageInfo: {
        val: 1,
        size: 10,
        total: 0
      },
      fadebackInfo: {
        id: 1,
        aid: 1,
        username: "",
        phonenumber: "",
        title: "",
        content: "",
        origin: null,
        flag: 1,
        solveflag: 0,
        solveaid: null,
        solveusername: null,
        solvecontent: null,
        createDate: "",
        updateDate: ""
      },
      centerDialogVisible: false,
      fadebackList: []
    }
  }
}
</script>

<style scoped>
.container_right {
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.el-dialog_header {
  padding: 0px
}
</style>